/* eslint-disable no-underscore-dangle */
import View from "./view/view"

export default class CommentVotesComponent {
  /**
   * Creates an instance of CommentVotesComponent.
   * @param {Object} settings
   * @param {HTMLElement} settings.htmlElement
   * @param {{ upvote: function(): void, downvote: function(): void }} settings.context
   * @memberof CommentVotesComponent
   */
  constructor({ context, htmlElement }) {
    this._view = new View(context, htmlElement)
  }

  /**
   * @param {{ commentVotes: CommentVotesEntity, commentId: String }} state
   * @memberof CommentVotesComponent
   */
  build(state) {
    this._view.update(state)
  }
}
